export default {
  RatingTeacher: {
    Teacher: 'Giáo viên {teacher}',
    Free: 'Sử dụng miễn phí <b>{numberPractice} học liệu</b>',
    FeatureUnlock: 'Mở khóa tính năng <b>{feature}</b>',
    IsMember: 'Là thành viên',
    ShareCommunity: 'Chia sẻ lên cộng đồng',
    Practice: '{number} học liệu',
    SISAPCommunity: 'Cộng đồng giáo viên SISAP',
    CreativeTeacher: 'Giáo viên sáng tạo',
    PositiveTeacher: 'Giáo viên tích cực',
    TechnologyTeacher: 'Giáo viên công nghệ',
    FourDotZeroTeacher: 'Giáo viên 4.0',
    TeacherCongrat: 'Chúc mừng thầy/cô',
    Achieve: 'Đạt danh hiệu',
    TeacherTitle: 'Giáo viên 4.0',
    TeacherDescription: 'Những đóng góp của thầy cô trong thời gian qua góp phần xây dựng cộng đồng giáo viên công nghệ sáng tạo và thúc đẩy công cuộc chuyển đổi số Quốc gia ngành giáo dục Việt Nam',
    TeacherSubDescription: 'Giờ đây thầy cô đã có thể trải nghiệm không giới hạn<br> các tính năng, tiện ích trên giải pháp học trực tuyến EMIS ÔN TẬP',
    TeacherAchievement: 'vinh-danh-giao-vien.png'
  },
  Community: {
    FreeAllExercise: 'Miễn phí toàn bộ học liệu',
    DecriptionCollect: '<p>Sau khi <b>Sưu tầm</b>, học liệu sẽ lưu về danh sách học liệu của bạn</p><p>và sẽ sử dụng <b>01</b> lượt <b>tham khảo của Thẻ học liệu</b></p><p>Bạn đồng ý chứ?</p>',
    NumberCollectRemaining: 'Còn {numberCollect} lượt Sưu tầm học liệu',
    OutOfTurnMarial: 'Hết lượt sử dụng học liệu',
    DescriptionOutOfTurnMarial: '<p>Bạn đã hết lượt sử dụng học liệu</p> <p>hãy chia sẻ {numberTopic} bộ đề nữa lên cộng đồng để nhận thêm lượt nhé</p>',
    OnlineClassroomDescription: 'Liên kết đa nền tảng Zoom, Google Meet, MS Teams',
    ComposeDescription: 'Hỗ trợ nhiều dạng soạn: ghép nối, đúng sai, câu hỏi nhóm...',
    MaterialCompose: 'Công cụ soạn bài',
    DiscoverNow: 'Khám phá ngay',
    NewStudySolution: 'GIẢI PHÁP HỌC TẬP TRỰC TUYẾN 4.0',
    WelcomeNewTeacher: 'Cộng đồng giáo viên trân trọng gửi tặng thầy/cô món quà chào mừng <b style="color: #FFD200">Giáo viên mới</b>',
    LibraryDescription: 'Hàng ngàn học liệu chất lượng đến từ cộng đồng giáo viên',
    TakeGiftSuccessfully: 'Nhận quà thành công',
    Amazing: 'TUYỆT VỜI',
    TeacherGratefulness: 'Cảm ơn thầy cô đã đồng hành và có những trải nghiệm thú vị trong thời gian qua. Cộng đồng giáo viên gửi tặng thầy cô một món quà tri ân',
    TakeGift: 'Nhận quà',
    ShareAchievements: 'Chia sẻ',
    GameGalacticTitle: 'Tính năng "tạo trò chơi" sẽ mở khóa ở cấp',
    OrganizeExamTitle: 'Tính năng "Tổ chức kiểm tra" sẽ mở khóa ở cấp',
    FillQuestionTitle: '"Câu điền vào chỗ trống" sẽ mở khóa ở cấp',
    EssayQuestionTitle: '"Câu tự luận" sẽ mở khóa ở cấp',
    GroupQuestionTitle: '"Câu hỏi nhóm" sẽ mở khóa ở cấp',
    PairingQuestionTitle: '"Câu ghép nối" sẽ mở khóa ở cấp',
    RepairExerciseTitle: 'Tính năng "chữa bài" sẽ mở khóa ở cấp',
    MixQuestionTitle: '"Câu tự luận" và "Câu điền từ" sẽ mở khóa ở cấp',
    LimitClassroomMessage: 'thầy/cô có thể quản lý thêm nhiều lớp học',
    LimitFavoutitExerciseMessage: 'thầy/cô có thể mở rộng danh sách học liệu yêu thích',
    LimitCollectExerciseMessage: 'thầy/cô có thể sưu tầm thêm nhiều học liệu trên cộng đồng',
    LimitComposeExerciseMessage: 'thầy/cô có thể lưu trữ thêm nhiều học liệu',
    LimitComposeExamMessage: 'thầy/cô có thể lưu trữ thêm nhiều đề thi',
    LimitClassroomTitle: 'thầy/cô đã có {number} lớp học',
    LimitFavoutitExerciseTitle: 'thầy/cô đã có {number} học liệu yêu thích',
    LimitCollectExerciseTitle: 'thầy/cô đã sử dụng {number} lượt sưu tầm học liệu',
    LimitComposeExerciseTitle: 'thầy/cô đã lưu trữ {number} học liệu cá nhân',
    LimitComposeExamTitle: 'thầy/cô đã lưu trữ {number} Đề thi',
    WhenAchieveRank: 'Khi đạt danh hiệu',
    LimmitTotalStudentClassroom: 'Thầy/cô đã quản lý số lượng học sinh tối đa trong một lớp',
    MessageCantApproveAllStudent: 'Thầy cô có thể phê duyệt <b>10 học sinh</b>',
    LevelUpGift: 'QUÀ TẶNG THẦY CÔ',
    GroupQuestionDescription: 'Sáng tạo bài tập với dạng Câu hỏi nhóm',
    CorrectingDescription: 'Mở khóa tính năng chữa bài trực quan và dễ dàng',
    ExamPeriodDescription: 'Mở khóa tính năng Tạo kỳ kiểm tra',
    StorageExtenceDescription: 'Kho học liệu cá nhân mở rộng lưu trữ tới {amount} học liệu',
    ClassAmountDescription: 'Thêm {amount} lượt tạo và quản lý lớp học',
    MappingQuestionDescription: 'Sáng tạo bài soạn với dạng câu Ghép - Nối',
    ExtraExerciseDescription: 'Nhận {amount} lượt sưu tầm học liệu từ cộng đồng',
    GalacticGameDescription: 'Mở khóa trò chơi Chiến binh thiên hà',
    FillAndEssayDescription: 'Thêm dạng bài Tự luận, Điền vào chỗ trống',
    ShareNow: 'Chia sẻ ngay',
    RecommendShareExercise: 'Chia sẻ thêm <b>{numberExercise}</b> học liệu,</br> thầy/cô sẽ đạt danh hiệu </br><b>{nameRanking}</b>',
    Gift: 'QUÀ TẶNG'
  }
}
